<template lang="pug">
  div.account
    div.login
      h3 已经有账号？登录
      div.email
        input(type="text", required)
        label
          span Email
      div.password
        input(type="password", required)
        label
          span Password
      p.tips 忘记用户名和密码 ?
      div.button
        button 登录
      div.remember
        input#remember(type="checkbox", name="checkbox", v-model="remember", hidden)
        label(for="remember")
          div.checkbox
            span.box
              i.fa.fa-check
            span remember me !

    div.new-customer
      h3 New Customer
      p
        small Creating an account is easy, and you'll enjoy the benefits of faster checkout, order history, a wish list and more.
      div.button
        button Create an Account
</template>
<script>
export default {
  name: 'Account',
  data () {
    return {
      account: '',
      password: '',
      remember: true
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../assets/common.scss";
.account {
  padding: 0 15px;
}
.button {
  text-align: center;
}
.button button {
  @extend %button;
  width: 100%;
}
.checkbox {
  height: 20px;
  line-height: 20px;
  text-align: center;
  display: flex;
  flex-flow: row nowrap;
    i {
      display: none;
    }
    .box {
      display: inline-block;
      border:1px solid #000;
      width: 20px;
      height: 20px;
      margin-right: 10px;
    }
}
.remember {
  margin-top: 0.5rem;
  display: flex;
  flex-flow: row nowrap;
}
.remember label {
  flex: 1;
}
.remember input:checked + label .checkbox i {
  display: inline-block;
}
.email,
.password {
  position: relative;
  margin-bottom: 15px;
  input {
    width: 100%;
    height: 3rem;
    border:1px solid $borderColor;
    padding: 0 15px;
  }
  label {
    position: absolute;
    left: 15px;
    top:0;
    line-height: 3rem;
      span:after{
        content:"*";
        color:red;
        line-height: 3rem;
        margin-left:3px;
      }
  }
}

.new-customer {
  margin-bottom: 25px;
}
</style>
